interface MemberAvatarsProps {
    members: Array<{ imageUrl?: string; givenName?: string; familyName?: string; email?: string }>;
    maxDisplay?: number;
}

export const MemberAvatars = ({ members, maxDisplay = 3 }: MemberAvatarsProps) => {
    const displayMembers = members.slice(0, maxDisplay);
    const remainingCount = members.length - maxDisplay;

    const getInitials = (member: { givenName?: string; familyName?: string; email?: string }) => {
        if (member.givenName) return member.givenName.charAt(0).toUpperCase();
        if (member.familyName) return member.familyName.charAt(0).toUpperCase();
        if (member.email) return member.email.charAt(0).toUpperCase();
        return '?';
    };

    return (
        <div className="member-avatars">
            {displayMembers.map((member, index) => (
                <div key={index} className="member-avatars__item">
                    {member.imageUrl ? (
                        <img src={member.imageUrl} alt={member.email || 'Member'} className="member-avatars__image" />
                    ) : (
                        <div className="member-avatars__placeholder">{getInitials(member)}</div>
                    )}
                </div>
            ))}
            {remainingCount > 0 && (
                <div className="member-avatars__item member-avatars__more">
                    <div className="member-avatars__placeholder">+{remainingCount}</div>
                </div>
            )}
        </div>
    );
};
